import { Map } from 'immutable';
import {actionTypes as actionTypes} from '../../actions/CoC/cocViewActions';

let defaultState = {
  loading: false,
  formData: null,
  cocId: null,
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.COC_VIEW_SET_COC_ID:
      return state.set('cocId', action.payload);
    case actionTypes.COC_VIEW_UNMOUNT:
      return Map(defaultState)
    default:
      return state;
  }
}
